<p-checkbox [binary]="true" inputId="binary"></p-checkbox>
